import React from "react";
import ReactMarkdown from "react-markdown";

export default function FeedbackMarkdownText({
  text,
  className = "",
  inline = false,
  components = {},
}) {
  const trimmed = String(text || "").trim();
  if (!trimmed) return null;

  return (
    <ReactMarkdown
      components={{
        p: ({ children }) =>
          inline ? <span className={className}>{children}</span> : <p className={className}>{children}</p>,
        strong: ({ children }) => (
          <strong className="summary-feedback-strong">{children}</strong>
        ),
        em: ({ children }) => <em>{children}</em>,
        ...components,
      }}
    >
      {trimmed}
    </ReactMarkdown>
  );
}
